import { inject, injectable } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import withCache from '@framework/with-cache';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';
import Request from '@framework/api/Rpc/Request';

@injectable()
class SectorRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher) {}

  @withCache
  async getList() {
    const request = new Request('finsight_web.market.get_sectors', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default SectorRepository;
